<template>
  <div>
    <div id="nav-box-buttons">
      <!-- Reactivate if a home view separate from the general study list is established -->
      <!-- <router-link
        :to="{ name: 'home' }"
        id="homeBtn"
        class="menu-box-btn"
        :class="{ 'menu-box-btn-active': $route.path === '/list/general' }"
        >Home</router-link
      > -->
      <router-link
        v-if="usrPermissions.createTrials"
        id="newTrialBtn"
        :class="{ 'menu-box-btn-active': $route.path === '/details/new' }"
        class="menu-box-btn"
        :to="{ name: 'details', query: { id: 'new' } }"
      >
        {{ t('topMenuBox.newStudy') }}
      </router-link>
      <router-link
        id="trialsListBtn"
        type="submit"
        :class="{ 'menu-box-btn-active': $route.path === '/list/general' }"
        class="menu-box-btn"
        :to="{ name: 'studyList' }"
        @click="filterManipulator.resetFilter()"
      >
        {{ t('topMenuBox.allStudies') }}
      </router-link>
      <router-link
        id="favouritesBtn"
        type="submit"
        :class="{ 'menu-box-btn-active': $route.path === '/list/favourites' }"
        class="menu-box-btn"
        :to="{ name: 'favourites' }"
      >
        {{ $t('topMenuBox.favorites') }}
      </router-link>
      <router-link
        v-if="usrPermissions.changeTrialInfoAdvanced"
        id="changeRequestBtn"
        :class="{ 'menu-box-btn-active': $route.path === '/change-requests' }"
        class="menu-box-btn"
        :to="{ name: 'changeRequests' }"
      >
        {{ t('topMenuBox.changeRequests') }}
      </router-link>
      <router-link
        v-else-if="!isPatientUser"
        id="myChangeRequestBtn"
        :class="{
          'menu-box-btn-active': $route.path === '/my-change-requests',
        }"
        class="menu-box-btn"
        :to="{ name: 'myChangeRequests' }"
      >
        {{ t('topMenuBox.myChangeRequests') }}
      </router-link>
      <a
        v-if="!isPatientUser"
        id="docs-link"
        target="_blank"
        :href="config.CATS_DOCS"
        class="menu-box-btn"
        >{{ t('topMenuBox.patientDocs') }}</a
      >
      <a
        v-if="isPatientUser"
        id="patient-docs-link"
        target="_blank"
        :href="config.CATS_DOCS_PATIENTS"
        class="menu-box-btn"
        >{{ t('topMenuBox.patientDocs') }}</a
      >
      <router-link
        id="optionBtn"
        :class="{ 'menu-box-btn-active': $route.path === '/settings' }"
        class="menu-box-btn"
        :to="{ name: 'settings' }"
      >
        {{ t('settings.settings') }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/userStore';
import { storeToRefs } from 'pinia';
import userManager from '@/helperScripts/userManagement/userManager';
import { useAuthStore } from '@/stores/authStore';
import { computed } from 'vue';
import config from '@/config';
import filterManipulator from '@/helperScripts/filter/filterManipulator';

const { t } = useI18n();

const { usrPermissions } = storeToRefs(useUserStore());

const isPatientUser = computed(() => userManager.isUserPatient(useAuthStore()));
</script>

<style scoped lang="scss">
@import '@/scss/__variables.scss';

#nav-box-buttons {
  display: flex;
}

.menu-box-btn {
  color: $default-light-grey;
  padding: 0 1em;
}

.menu-box-btn-active {
  color: $default-text-black;
  font-weight: bold;
}

//Mobile (<1400px): the nav buttons stack as full-width rows inside the top
//bar's dropdown sheet (styled in TopBar.vue).
@media screen and (max-width: 1399px) {
  #nav-box-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .menu-box-btn {
    display: block;
    padding: 0.75em 1.25em;
    min-height: 44px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.06);
  }

  .menu-box-btn:hover,
  .menu-box-btn:active {
    background-color: $vitu-background;
  }

  //Active route gets a green accent bar so the current section is obvious
  .menu-box-btn-active {
    background-color: $vitu-background;
    border-left: solid 3px $vitu-green;
    //Compensates the left border so the text stays aligned with the other rows
    padding-left: calc(1.25em - 3px);
  }
}
</style>
